import { createSelector } from 'reselect';
import getStoreProductDetails from '../../utils/getStoreProductDetails';

export default createSelector(
  (state) => state,

  // WORKAROUND: The tests will fail if we just use getStoreProductDetails, so this 
  // [x => f(x)] expression is required.
  (state) => getStoreProductDetails(state),
);
